import { Routes } from '@angular/router';
import { App } from './app';

export const routes: Routes = [
  { path: 'initialize', loadComponent: () => import('./initialize/initialize').then((m) => m.Initialize) },
  { path: '', pathMatch: 'full', loadComponent: () => import('./welcome/welcome').then((m) => m.Welcome) },
  { path: ':path', component: App },
];
